// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.border-bottom[data-v-060764cd] {\n  border-bottom: 1px solid #232d4d5a;\n  border-color: #232d4d5a !important;\n}\n.metric-chart[data-v-060764cd] {\n  background: var(--surface-1);\n  padding: 1rem;\n  border-radius: 0.75rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
